import React, {useMemo} from "react";
import {DictPO} from "@/model/system";
import {useAllDict} from "@/store/dict.c";
import {Autocomplete, FormLabel} from "@mui/material";
import {Controller, UseFormSetValue} from "react-hook-form";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import {Control} from "react-hook-form/dist/types/form";

export type GroupProductType = {
    group: string
    label: string
    value: string
}

interface GroupProductProps<T> {
    label: string
    errMsg?: string
    attr: string
    attrId: string
    setValue: UseFormSetValue<any>
    control: Control<any, Partial<T>>
    required?: boolean
    onSelect?: (item: T) => void
}

export const GroupProduct = <T, >({attr, setValue, onSelect, required = true, attrId, errMsg, label, control}: GroupProductProps<T>) => {
    const {contractType, patentKind, trademarkKind, copyrightKind, projectKind} = useAllDict()
    const products: GroupProductType[] = useMemo(() => {
        const proCat: { [key: number]: DictPO[] } = {1: patentKind, 2: projectKind, 3: trademarkKind, 4: copyrightKind}
        return contractType?.map((item): GroupProductType[] => {
            if (item.value == 5) {
                return [{group: item.label, label: item.label, value: `${item.value},${item.value}`}]
            } else {
                return proCat[item.value]?.map(k => ({group: item.label, label: k.label, value: `${item.value},${k.value}`}))
            }
        })?.flat()
    }, [contractType, patentKind, trademarkKind, copyrightKind, projectKind]);

    return <FormControl fullWidth={true} required={required}>
        <FormLabel>{label}</FormLabel>
        <Controller
            key={attr}
            control={control}
            name={attr}
            render={({field: {onChange, value}}) => {
                return (
                    <Autocomplete
                        id={attr}
                        onChange={(_, data) => {
                            onChange(data?.label)
                            setValue(attrId, data?.value)
                            onSelect && onSelect(data as T)
                        }}
                        key={attr}
                        value={value || ''}
                        groupBy={(option: GroupProductType) => option?.group}
                        // getOptionLabel={(option: GroupProductType) => option.label}
                        // getOptionKey={(option: GroupProductType) => option.value}
                        options={products}
                        fullWidth
                        renderInput={(params) => (
                            <TextField
                                error={!!errMsg}
                                helperText={errMsg}
                                placeholder={`选择${label}`}
                                {...params}
                            />
                        )}
                    />
                )
            }}
        /></FormControl>
}